enum SourceType {
    Text,
    Version,
    Parsing,
    Stems,
    Transliteration
}

export default SourceType;
